import { useContext } from 'react'
import ClientContext from 'contexts/ClientContext'
import classNames from 'classnames'
import style from './Button.module.scss'

const Button = ({ className, disabled, label, onClick, styles, type }) => {
  const { color } = useContext(ClientContext)

  return (
    <button
      className={classNames(style.button, style[type], className, color && style.colabel)}
      disabled={disabled}
      onClick={onClick}
      style={{
        background: type === 'primary' && color,
        borderColor: type === 'secondary' && color,
        color: type === 'secondary' && color,
        ...styles
      }}
    >
      {label}
    </button>
  )
}

export default Button
